import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectDarkVenueHeatmapWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.DARK_VENUE_HEATMAP];

export const selectDarkVenueHeatmapWidgetState = (
    state: State,
    widgetKey: string
) => selectDarkVenueHeatmapWidgetsState(state)[widgetKey];
